import F from "./extends3.mjs";
import N from "./objectWithoutPropertiesLoose3.mjs";
import * as c from "react";
import { useViews as j } from "./useViews.mjs";
import { isTimeView as z } from "./time-utils.mjs";
import A from "./useEventCallback.mjs";
import I from "./useEnhancedEffect.mjs";
const G = ["className", "sx"], K = ({
  props: V,
  propsFromPickerValue: a,
  additionalViewProps: U,
  inputRef: m,
  autoFocusView: v
}) => {
  const {
    onChange: g,
    open: w,
    onSelectedSectionsChange: M,
    onClose: T
  } = a, {
    views: i,
    openTo: k,
    onViewChange: x,
    disableOpenPicker: p,
    viewRenderers: t,
    timezone: P
  } = V, L = N(V, G), {
    view: o,
    setView: f,
    defaultView: d,
    focusedView: S,
    setFocusedView: h,
    setValueAndGoToNextView: b
  } = j({
    view: void 0,
    views: i,
    openTo: k,
    onChange: g,
    onViewChange: x,
    autoFocus: v
  }), {
    hasUIView: E,
    viewModeLookup: u
  } = c.useMemo(() => i.reduce((e, s) => {
    let r;
    return p ? r = "field" : t[s] != null ? r = "UI" : r = "field", e.viewModeLookup[s] = r, r === "UI" && (e.hasUIView = !0), e;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [p, t, i]), C = c.useMemo(() => i.reduce((e, s) => t[s] != null && z(s) ? e + 1 : e, 0), [t, i]), l = u[o], _ = A(() => l === "UI"), [n, y] = c.useState(l === "UI" ? o : null);
  return n !== o && u[o] === "UI" && y(o), I(() => {
    l === "field" && w && (T(), setTimeout(() => {
      m?.current.focus(), M(o);
    }));
  }, [o]), I(() => {
    if (!w)
      return;
    let e = o;
    l === "field" && n != null && (e = n), e !== d && u[e] === "UI" && u[d] === "UI" && (e = d), e !== o && f(e), h(e, !0);
  }, [w]), {
    hasUIView: E,
    shouldRestoreFocus: _,
    layoutProps: {
      views: i,
      view: n,
      onViewChange: f
    },
    renderCurrentView: () => {
      if (n == null)
        return null;
      const e = t[n];
      return e == null ? null : e(F({}, L, U, a, {
        views: i,
        timezone: P,
        onChange: b,
        view: n,
        onViewChange: f,
        focusedView: S,
        onFocusedViewChange: h,
        showViewSwitcher: C > 1,
        timeViewsCount: C
      }));
    }
  };
};
export {
  K as usePickerViews
};
//# sourceMappingURL=usePickerViews.mjs.map
